import { motion } from "framer-motion";
import type { WineCardData } from "./types";

interface Props {
  data: WineCardData;
}

function Stat({ label, value, mono }: { label: string; value?: string | number; mono?: boolean }) {
  if (value === undefined || value === null || value === "") return null;
  return (
    <div>
      <p className="mw-stat-label">{label}</p>
      <p className={`mw-stat-value ${mono ? "mw-mono" : ""}`}>{String(value)}</p>
    </div>
  );
}

export function WineCard({ data }: Props) {
  const hasAnyStat =
    data.investmentGrade ||
    data.cruLevel ||
    data.drinkingWindow ||
    data.priceRange ||
    data.rating ||
    data.rarity ||
    data.style ||
    data.alcohol ||
    data.aging ||
    data.oak ||
    data.appellation ||
    data.collectorDemand ||
    data.marketLiquidity ||
    data.investmentSignal ||
    data.peak ||
    data.bottleFormat ||
    data.grapes;

  return (
    <motion.div
      className="mw-card-wrap"
      initial={{ opacity: 0, y: 12, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="mw-card">
        <span className="mw-corner bl" />
        <span className="mw-corner br" />

        <div className="mw-card-header">
          {data.region && <p className="mw-card-region">{data.region}</p>}
          {data.name && <h3 className="mw-card-name">{data.name}</h3>}
          {data.producer && <p className="mw-card-producer">{data.producer}</p>}
          {data.vintage && <p className="mw-card-vintage">{data.vintage}</p>}
        </div>

        {data.description && <p className="mw-card-section">{data.description}</p>}

        {data.tastingNotes && (
          <div className="mw-card-notes">
            <p className="mw-card-notes-label">Tasting Notes</p>
            <p className="mw-card-notes-body">{data.tastingNotes}</p>
          </div>
        )}

        {hasAnyStat && (
          <div className="mw-card-grid">
            <Stat label="Inv. Grade" value={data.investmentGrade} />
            <Stat label="Cru Level" value={data.cruLevel} />
            <Stat label="Appellation" value={data.appellation} mono />
            <Stat label="Drink Window" value={data.drinkingWindow} mono />
            <Stat label="Peak" value={data.peak} mono />
            <Stat label="Est. Value" value={data.priceRange} mono />
            <Stat label="Rating" value={data.rating} mono />
            <Stat label="Rarity" value={data.rarity} mono />
            <Stat label="Style" value={data.style} mono />
            <Stat label="Grapes" value={data.grapes} mono />
            <Stat label="Alcohol" value={data.alcohol} mono />
            <Stat label="Aging" value={data.aging} mono />
            <Stat label="Oak" value={data.oak} mono />
            <Stat label="Bottle" value={data.bottleFormat} mono />
            <Stat label="Demand" value={data.collectorDemand} mono />
            <Stat label="Liquidity" value={data.marketLiquidity} mono />
            {data.investmentSignal && (
              <div>
                <p className="mw-stat-label">Signal</p>
                <span className="mw-signal">{data.investmentSignal}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </motion.div>
  );
}
